import { Divider } from "antd";
import { Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";

import { formatNumber } from "lib/utility";

import "./Product.css";
const ProductCard = ({ product }) => {
  const history = useHistory();

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: ".2" }}
        className="h-100"
      >
        <Card className="border-0 product-card">
          <Card.Img
            variant="top"
            src={`/assets/img/products/${product.image}`}
            className="product-card-image"
          />
          <i className="fas fa-heart card-wishlist hover-pointer" />
          <Card.Body
            className="p-2 product-card-body hover-pointer"
            onClick={() => history.push(`/products/${product.name}`)}
          >
            <div className="product-card-body-title">{product.name}</div>
            <div className="product-card-body-price">Rp {formatNumber(product.price)}</div>

            <div className="w-100 text-muted small fw-light">
              <i className="fal fa-eye me-1" />
              <span className="fw-light">{Math.floor(Math.random() * 8 + 1)}rb</span>

              <Divider
                type="vertical"
                className="mx-1"
                style={{ borderColor: "#31353b52", height: "0.7em", top: "0.02em" }}
              />

              <span className="va-middle text-truncate">
                Tersewa {Math.floor(Math.random() * 8 + 1)}rb
              </span>
            </div>
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
};

export default ProductCard;
